import { ILastState } from '../../state/types';
import { makeManagedSourceSetFetch } from './_shared/fetchMakers';
import { normalizeSingleEntity } from './_shared/normalizers';
import { makeLastStatesUrl } from './_shared/urlMakers';

export const fetchLastStates = makeManagedSourceSetFetch<ILastState[]>(
    makeLastStatesUrl,
    normalizeSingleEntity
);
